import {HttpMethod, HttpRequest, HttpResponse, Middleware, newFileResponse, None} from '#wexen';
import {existsSync, statSync} from 'node:fs';
import {resolve} from 'node:path';

export function staticFilesMiddleware(staticFileDirectories: string[]): Middleware {
  return async (request: HttpRequest): Promise<HttpResponse | None> => {
    if (request.method !== HttpMethod.Get) {
      return null;
    }

    const requestPath = request.url.pathname.slice(1) || 'index.html';

    for (const directory of staticFileDirectories) {
      const path = resolve(directory, requestPath);

      if (path && existsSync(path) && statSync(path).isFile()) {
        return newFileResponse(path);
      }
    }
  };
}
